// GAVION outlook-parity: stop-request id carried by an email_stop_request notification link (?stop_request=<id>).
export const stopRequestIdOf = (
  kind: string,
  link: string | null,
): number | null => {
  if (kind !== "email_stop_request" || !link) return null;
  const m = /[?&]stop_request=(\d{1,18})(?:&|#|$)/.exec(link);
  return m ? Number(m[1]) : null;
};
